if($('.reviews').length){

    const storageKey = 'storeRatingData-' + document.location.host;
    function generateStars(score) {
      const full = Math.floor(score);
      const half = score % 1 >= 0.5;
      let html = '';
  
      for (let i = 0; i < full; i++) {
        html += '<span class="star star-on"></span>';
      }
      if (half && full < 5) {
        html += '<span class="star star-half"></span>';
      }
      return html;
    }
    function renderRating(data) {
   
      const d = typeof data === 'string' ? JSON.parse(data) : data;
      const ratings = d.ratings?.slice(0, 3) || [];
      const reviewHtml = ratings.map(r => `
        <div class="review-item">
          <div class="inner">
            <div class="header">              
              <div class="review-stars"><span class="stars">${generateStars(parseFloat(r.score) || 0)}</span></div>
              <div class="review-name">${r.fullName || 'Ověrené hodn...'}</div>
            </div>
            <div class="review-description">${r.description}</div>
          </div>
        </div>
      `).join('');
      $('.reviews .reviewsInner .right').html(reviewHtml);
      $('.reviews .reviewsInner .left').prepend('<p class="reviewsCount">'+d.averageScore+'</p>');
      $('.reviews .reviewsInner .left').prepend('<span class="stars">'+generateStars(parseFloat(d.averageScore) || 0)+'</span>');
      
    }
    const stored = sessionStorage.getItem(storageKey);
    if (stored) {
      renderRating(JSON.parse(stored));
    } else {
      $.ajax({
        url: '/hodnoceni-obchodu/?jsonFormat',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Store-Rating-Details': 'true'
        },
        success: function (response) {
          sessionStorage.setItem(storageKey, JSON.stringify(response));
          renderRating(response);
        },
        error: function (xhr, status, error) {
          console.error('Chyba při načítání hodnocení:', error);
        }
      });
    }
}